import { selector } from 'recoil';
import { MassAction } from './DataGrid';
import propsState from './props.state';

const massActionsQuery = selector<MassAction[]>({
  key: 'massActions',
  get: ({ get }) => {
    const props = get(propsState);

    if (!props) {
      return [];
    }

    return props.massActions || [];
  },
});

export default massActionsQuery;
